module.exports = require("path-is-absolute");


//////////////////
// WEBPACK FOOTER
// external "path-is-absolute"
// module id = 75
// module chunks = 0 1 2 3 4 5 6 7 10 11